/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BaseRequest,
    BaseRequestFromJSON,
    RequestComments,
    RequestCommentsFromJSON,
    RequestType,
    RequestTypeFromJSON,
    UserRequests,
    UserRequestsFromJSON,
} from '../models';

export interface CreateRequestApiRequestsCreateRequestPostRequest {
    summary: string;
    description: string;
    companyCode: string;
    requestTypeId: string;
    uploadFiles?: Blob[];
}

export interface GetCommentsByRequestApiRequestsRequestCommentsGetRequest {
    requestId: string;
    page?: number;
}

export interface GetRequestApiRequestsUserRequestsGetRequest {
    page: number;
}

/**
 *
 */
export class RequestsApi extends runtime.BaseAPI {

    /**
     * Create Request
     */
    async createRequestApiRequestsCreateRequestPostRaw(requestParameters: CreateRequestApiRequestsCreateRequestPostRequest): Promise<runtime.ApiResponse<BaseRequest>> {
        if (requestParameters.summary === null || requestParameters.summary === undefined) {
            throw new runtime.RequiredError('summary','Required parameter requestParameters.summary was null or undefined when calling createRequestApiRequestsCreateRequestPost.');
        }

        if (requestParameters.description === null || requestParameters.description === undefined) {
            throw new runtime.RequiredError('description','Required parameter requestParameters.description was null or undefined when calling createRequestApiRequestsCreateRequestPost.');
        }

        if (requestParameters.companyCode === null || requestParameters.companyCode === undefined) {
            throw new runtime.RequiredError('companyCode','Required parameter requestParameters.companyCode was null or undefined when calling createRequestApiRequestsCreateRequestPost.');
        }

        if (requestParameters.requestTypeId === null || requestParameters.requestTypeId === undefined) {
            throw new runtime.RequiredError('requestTypeId','Required parameter requestParameters.requestTypeId was null or undefined when calling createRequestApiRequestsCreateRequestPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.uploadFiles) {
            requestParameters.uploadFiles.forEach((element) => {
                formParams.append('upload_files', element as any);
            })
        }

        if (requestParameters.summary !== undefined) {
            formParams.append('summary', requestParameters.summary as any);
        }

        if (requestParameters.description !== undefined) {
            formParams.append('description', requestParameters.description as any);
        }

        if (requestParameters.companyCode !== undefined) {
            formParams.append('company_code', requestParameters.companyCode as any);
        }

        if (requestParameters.requestTypeId !== undefined) {
            formParams.append('request_type_id', requestParameters.requestTypeId as any);
        }

        const response = await this.request({
            path: `/api/requests/create_request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseRequestFromJSON(jsonValue));
    }

    /**
     * Create Request
     */
    async createRequestApiRequestsCreateRequestPost(requestParameters: CreateRequestApiRequestsCreateRequestPostRequest): Promise<BaseRequest> {
        const response = await this.createRequestApiRequestsCreateRequestPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get Available Request Types
     */
    async getAvailableRequestTypesApiRequestsAvailableRequestTypesGetRaw(): Promise<runtime.ApiResponse<RequestType[]>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/requests/available-request-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RequestTypeFromJSON));
    }

    /**
     * Get Available Request Types
     */
    async getAvailableRequestTypesApiRequestsAvailableRequestTypesGet(): Promise<RequestType[]> {
        const response = await this.getAvailableRequestTypesApiRequestsAvailableRequestTypesGetRaw();
        return await response.value();
    }

    /**
     * Get Comments By Request
     */
    async getCommentsByRequestApiRequestsRequestCommentsGetRaw(requestParameters: GetCommentsByRequestApiRequestsRequestCommentsGetRequest): Promise<runtime.ApiResponse<RequestComments>> {
        if (requestParameters.requestId === null || requestParameters.requestId === undefined) {
            throw new runtime.RequiredError('requestId','Required parameter requestParameters.requestId was null or undefined when calling getCommentsByRequestApiRequestsRequestCommentsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.requestId !== undefined) {
            queryParameters['request_id'] = requestParameters.requestId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/requests/request_comments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => RequestCommentsFromJSON(jsonValue));
    }

    /**
     * Get Comments By Request
     */
    async getCommentsByRequestApiRequestsRequestCommentsGet(requestParameters: GetCommentsByRequestApiRequestsRequestCommentsGetRequest): Promise<RequestComments> {
        const response = await this.getCommentsByRequestApiRequestsRequestCommentsGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get Request
     */
    async getRequestApiRequestsUserRequestsGetRaw(requestParameters: GetRequestApiRequestsUserRequestsGetRequest): Promise<runtime.ApiResponse<UserRequests>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling getRequestApiRequestsUserRequestsGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/requests/user_requests`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserRequestsFromJSON(jsonValue));
    }

    /**
     * Get Request
     */
    async getRequestApiRequestsUserRequestsGet(requestParameters: GetRequestApiRequestsUserRequestsGetRequest): Promise<UserRequests> {
        const response = await this.getRequestApiRequestsUserRequestsGetRaw(requestParameters);
        return await response.value();
    }

}
